import _indexOf from 'lodash/indexOf';

import { requestVideoPlayerPlaybackRate } from 'actions/videoPlayer';
import { store } from 'utilities/store';

import { PLAYBACK_RATES } from '../components/video-player/constants/playback';

const SORTED_PLAYBACK_RATES = PLAYBACK_RATES.slice().sort();

export function useRateToggle(playbackRate) {
  const currentRateIndex = _indexOf(SORTED_PLAYBACK_RATES, playbackRate);

  if (currentRateIndex === -1) {
    return;
  }

  let nextRateIndex = currentRateIndex + 1;

  if (nextRateIndex >= SORTED_PLAYBACK_RATES.length) {
    nextRateIndex = 0;
  }

  store.dispatch(
    requestVideoPlayerPlaybackRate(SORTED_PLAYBACK_RATES[nextRateIndex])
  );
}
